import type { SVGProps } from 'react'

/**
 * Icone SVG minime condivise.
 *
 * Sostituiscono i glifi tipografici usati come icone (`→`, `‹`, `›`, `☰`, `×`):
 * un glifo non ha semantica, viene letto o ignorato in modo incoerente dagli
 * screen reader e cambia forma con il font. Le icone sono `aria-hidden` per
 * default: l'etichetta accessibile va sul controllo che le contiene.
 *
 * Uso: `<ArrowRight className="h-4 w-4" />`
 */

type IconProps = SVGProps<SVGSVGElement>

export function ArrowRight({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M4 10h11m0 0-4.2-4.2M15 10l-4.2 4.2"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ChevronLeft({ className, ...props }: IconProps) {
  return (
    <svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" fill="none" className={className} {...props}>
      <path d="M12.5 5 7.5 10l5 5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function ChevronRight({ className, ...props }: IconProps) {
  return (
    <svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" fill="none" className={className} {...props}>
      <path d="m7.5 5 5 5-5 5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function MenuIcon({ className, ...props }: IconProps) {
  return (
    <svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" fill="none" className={className} {...props}>
      <path d="M3.5 6h13M3.5 10h13M3.5 14h13" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  )
}

export function CloseIcon({ className, ...props }: IconProps) {
  return (
    <svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" fill="none" className={className} {...props}>
      <path d="M5.5 5.5l9 9m0-9-9 9" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  )
}
